import * as Scrivito from "scrivito";
import {
  defaultPageEditingConfigAttributes,
  defaultPageInitialContent,
  defaultPageProperties,
  defaultPropertiesGroups,
} from "objs/_defaultPageEditingConfig";
import {
  metadataEditingConfigAttributes,
  metadataInitialContent,
  metadataPropertiesGroups,
  metadataValidations,
} from "objs/_metadataEditingConfig";

Scrivito.provideEditingConfig("TextImage2dSlide", {
  title: "TextImage2dSlide",
  attributes: {
    ...defaultPageEditingConfigAttributes,
    ...metadataEditingConfigAttributes,
  },
  properties: [
    "subtitle",
    "imageLeft",
    "backgroundImage",
    ...defaultPageProperties,
  ],
  propertiesGroups: [
    {
      title: "Advanced",
      properties: ["body", "imageBottom", "sortKey", "targetLink"],
    },
    ...defaultPropertiesGroups,
    ...metadataPropertiesGroups,
  ],
  initialContent: {
    ...defaultPageInitialContent,
    ...metadataInitialContent,
  },
  validations: [...metadataValidations],
});
